module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"personal-property-limit-exceed-label":"Plus de {limit} biens sélectionnés","add-label":"Ajouter"}}')
  delete Component.options._Ctor
}
